import { EBehavior } from '../../../../../enums/EBehavior';
export function getNestedCheckboxTheme(behavior, withoutTitle) {
  var themeNesting = withoutTitle ? 'titled' : 'nested';

  switch (behavior) {
    case EBehavior.Multiply:
      return "".concat(themeNesting, "-checkbox");

    case EBehavior.Single:
    case EBehavior.SingleInOneGroup:
      return "".concat(themeNesting, "-checkmark");
  }
}